import React from 'react';
import Adds from 'modules/Adds';
import Header from 'modules/header/farm/main';
import {useLocation} from 'react-router';


const AddsContainer = () => {
  const {state} = useLocation();
  return (
    <div className="w-full h-full">
      <Header title={state?.title} />
      <Adds app="farm" />
    </div>
  );
};

export default AddsContainer;
